export const LOAN_DETAILS_ACTION_TYPES = {
  GET_LOAN_DETAILS: 'loanDetails/GET_LOAN_DETAILS',
};
